import type {ListThirdPartyRentalAssetOfferingsOptions} from './schemas'

export const rentalAssetKeys = {
    types: (includeArchived?: boolean) => ['rental-asset-types', {includeArchived}] as const,
    type: (id: string) => ['rental-asset-types', id] as const,
    assets: (filters?: {rentalAssetTypeId?: string; includeArchived?: boolean}) =>
        ['rental-assets', filters] as const,
    asset: (id: string) => ['rental-assets', id] as const,
    assignments: (assetId: string, dateFrom: string, dateTo: string) =>
        ['rental-assets', assetId, 'assignments', dateFrom, dateTo] as const,
    companies: () => ['third-party-rental-companies'] as const,
    offerings: (filters?: ListThirdPartyRentalAssetOfferingsOptions) =>
        ['third-party-rental-asset-offerings', filters] as const,
    stockSummaries: () => ['equipment-stock-summaries'] as const,
    stockSummary: (typeId: string) => ['rental-asset-types', typeId, 'stock-summary'] as const,
    typeFleet: (typeId: string) => ['rental-asset-types', typeId, 'fleet'] as const,
}
